import './style.css';
import "ol/ol.css"
import "ol-ext/dist/ol-ext.css"
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
//import VectorImage from 'ol/layer/VectorImage.js';
import VectorLayer from 'ol/layer/Vector';
//import Vector from 'ol/source/Vector.js';
import ImageWMS from 'ol/source/ImageWMS.js';
import GEOJSON from 'ol/format/GeoJSON.js';
import {fromLonLat as fo} from 'ol/proj.js';
import {Circle as CircleStyle, Fill, Stroke, Style, Text} from 'ol/style.js';
//import Print from 'ol-ext/control/Print.js';
import {Image as ImageLayer} from 'ol/layer.js';
//import {Projection as proj1} from 'ol/proj';
import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
//import Bbox from 'ol/format/filter/Bbox.js';
import {transformExtent} from 'ol/proj.js';
//import Feature from 'ol/Feature';
//import Point from 'ol/geom/Point';
//import Circle from 'ol/geom/Circle';
//import { transform } from 'ol/proj';
//import { boundingExtent } from 'ol/extent';
//import Control from 'ol/control/Control.js';
import 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
import VectorSource from 'ol/source/Vector';
//import { none } from 'ol/centerconstraint';
var lestyp="x";
var zoomLevel;
//const lesvector = new Vector();
var consolelog1;
var lbl_LES_anzeigen=false;

document.addEventListener('DOMContentLoaded', function () {
  
  
  consolelog1 = document.getElementById('consolelog');
  //consolelog.innerHTML = "geladen";
// initial keine Auswahl von LES-Typ, damit zunächst kein Blink-Effekt...
const radiobutton = document.getElementById('reset');
if(radiobutton) {
  radiobutton.checked = true;
}


const extent_Bargfeld = transformExtent([
  10.122780, // minX bei Rade
  53.734593, // minY
  10.254632,  // maxX
  53.798617   // maxY
],'EPSG:4326','EPSG:3857');

// OSM Layer definieren ...
const osm1 = new TileLayer({
      source: new OSM(),
      title: 'OSM',
      opacity: 1.0
      
    });


// Vektorquelle mit Löschwasserentnahme-Stellen Koordinaten definieren...
 const lesvector = new VectorSource({
  url: 'LES.geojson',
  format: new GEOJSON()
  }  ); 

  const lesvector300m = new VectorSource({
    url: 'LES.geojson',
    format: new GEOJSON()
    }  ); 

  
// neue Vekorquelle für Kreise definieren ...

//initialer Kreis-Stil für LES - Layer definieren ...
const image = new CircleStyle({
    radius: 2,
    fill:null,
    stroke: new Stroke({color: 'red', width: 5
    })
  });

    
const polystyle = new Style({image: image});

// Funktion, um einen Style für Kreise zu erstellen
const circleStyle1 = new Style({
  
  fill: new Fill({
    color: 'rgba(255, 0, 0, 0.3)' // Rote, transparente Füllung
  }),
  radius: 500,
  stroke: new Stroke({
    color: 'red',
    width: 50
  })
});

const les300m = new VectorLayer({
  source: lesvector300m, 
  //Projection: 'EPSG:3857',
  title: 'LES 300m Radius',
  style: circleStyle1,
  //minZoom: 13.5,  
  
  //minZoom: 13.5,
  opacity:  1 // initial nicht voll sichtbar...
  });
les300m.setVisible(false);
//consolelog1.innerHTML = lesvector300m.getFeatures().length;
  
// Vektorlayer LES definieren und Style zuweisen...
const les = new VectorLayer({
source: lesvector,
title: 'LES',
style: polystyle,
minZoom: 13.5
});
var counter=0;

var ortho = new ImageLayer({
source: new ImageWMS ({
//projection: projx,
url: 'https://dienste.gdi-sh.de//WMS_SH_DOP20col_OpenGBD?',
params: {LAYERS: 'sh_dop20_rgb',VERSION:'1.3.0' }}),
title: 'DOP20', 
opacity: 0 // initial nicht sichtbar ...
});
//ortho.setVisible(false);
// map erstellen

const map = new Map({
  target: 'map',
  layers: [
  osm1,ortho,les300m,les
  ],
  view: new View({
    center: fo([10.187202,53.767483]),
    zoom: 14,
    //minzoom: 16,
    //maxzoom: 20,
    extent: extent_Bargfeld
  })
});

let labeltext =  ""  ;
var labelfont;
var labelfill;
var labelstroke;
var labelbackgroundFill;
var labelbackgroundStroke;

/* les300m.once('change:visible', function() {
  if (layer.getVisible()) {
    map.dispatchEvent('moveend');
} else {
  map.dispatchEvent('moveend'); 
}
});  */

map.on('moveend', function () {
  //makeKreise();
  zoomLevel = map.getView().getZoom();
  document.getElementById('h5x').innerHTML = "Zoomlevel: " + zoomLevel.toFixed(1);
  const view = map.getView();
  const resolution = view.getResolution();
  
  const les300_upd = function les300_update_Style () {
    lesvector300m.getFeatures().forEach((feature) => {


      feature.setStyle( new Style({
        image: new CircleStyle({
          radius: 300/resolution,
          fill: new Fill({ 
          color: 'rgba(255, 0, 0, 0.02)',
            
           }),
          stroke: new Stroke({ 
            color: 'black',
            width: 0.3 }),
            blendMode: 'destination-out' // Mischen von überlappenden Farben verhindern
          
        })
        
      }));

    });
  }
  
  les300_upd();
  
  //consolelog1.innerHTML = counter;//lesvector300m.getFeatures().length;
  
  if (zoomLevel > 15.3 && lbl_LES_anzeigen) {
    //if (true) {
    
    labelfont ='10px sans-serif';
    labelfill = new Fill({ color: 'black' });
    labelstroke = new Stroke({ color: 'white', width: 2 });
    labelbackgroundFill = new Fill ({color: 'white'}); // Umrissfarbe für besseren Kontrast
    labelbackgroundStroke = new Stroke({color: 'black', width: 1});
  } else {
      labelfont ='0px sans-serif ';
      labelfill = new Fill({ color: 'rgba(0,0,0,0.0)' });
      labelstroke = new Stroke({ color: 'rgba(0,0,0,0.0', width: 2 });
      labelbackgroundFill = new Fill ({color: 'rgba(0,0,0,0.0'}); // Umrissfarbe für besseren Kontrast 
      labelbackgroundStroke = new Stroke({color: 'rgba(0,0,0,0.0', width: 1});
    }


    


});

// Variable für Blinkstatus
let isVisible = true;

// Funktion zum Blinken der Punkte
setInterval(() => {

  //if (lestyp != "reset") {

  // Alle Features des Layers durchlaufen und die Sichtbarkeit umschalten
  lesvector.getFeatures().forEach((feature) => {
    // Aktuellen Stil setzen (sichtbar oder transparent)
    if (feature.get('Typ') == lestyp) {
    feature.setStyle( new Style({
      image: new CircleStyle({
        radius: isVisible ? 4:6,
        fill: new Fill({ color: isVisible ? 'red' : 'yellow' }),
        stroke: new Stroke({ color: isVisible ? 'black': 'green', width: isVisible ? 1:2 })
      }), 
      // labeltext 
      text: new Text({

        text: feature.get('Typ'),  // Text des Labels
        font: labelfont,  // Schriftart
        fill: labelfill,  // Textfarbe
        stroke: labelstroke,  // Umrissfarbe für besseren Kontrast
        offsetY: 15,  // Position des Labels oberhalb des Punktes
        backgroundFill: labelbackgroundFill,
        backgroundStroke: labelbackgroundStroke
      })
       
      
    })); } else {
      feature.setStyle( new Style({
        image: new CircleStyle({
          radius: 4,
          fill: new Fill({ color: 'red' }),
          stroke: new Stroke({ color: 'black', width: 1})
        }), 
        
        text: new Text({
  
          text: feature.get('Nr') + '\n' + feature.get('Typ') + '-' + feature.get('Nennweite'),  // Text des Labels
          font: labelfont,  // Schriftart
          fill: labelfill,  // Textfarbe
          stroke: labelstroke,
          backgroundFill: labelbackgroundFill,
          backgroundStroke: labelbackgroundStroke,
          offsetY: 22,  // Position des Labels oberhalb des Punktes
          offsetX: 15
        })
      }));
    }
  }
  
);

  // Sichtbarkeit umschalten
  isVisible = !isVisible;
//}
}, 500); // Alle 500 ms blinkt der Punkt


var layersw = new LayerSwitcher();
map.addControl(layersw);

les300m.on('change:visible', function(event) {

  if (les300m.getVisible() ) {
     // timeout musste gesetzt werden, da ansonsten beim ersten aktivieren 'moveend' nicht ausgelöst wird...
    setTimeout(() => {
     map.dispatchEvent('moveend'); 
  }, 100);
   
    
    //les300_upd;
  }
  

});




const lesform = document.getElementById('group1');
lesform.addEventListener('change', (event) => {
  var selectedValue;
  // Überprüfen, ob das Event von einem Input-Element stammt
  if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
    selectedValue = event.target.value; // Wert speichern
    //console.log('Ausgewählter Wert:', selectedValue);
    lestyp = selectedValue;
  }
});
const cbx_lbl = document.getElementById('cbx_lbl_onoff');
cbx_lbl.addEventListener('change', (event) => {
  if(event.target.checked){
    lbl_LES_anzeigen = true;
    map.dispatchEvent('moveend'); // moveend manuell auslösen damit label umgehend angezeigt werden
  } else {
    lbl_LES_anzeigen = false;
    map.dispatchEvent('moveend');
  }

});
 
// Druckfunktion
document.getElementById('printButton').addEventListener('click', async () => {
  const orientation = document.getElementById('orientation').value; // Hochformat/Querformat
  const pageSize = document.getElementById('pageSize').value; // A4/A3
  const scale = parseFloat(document.getElementById('scale').value); // Maßstab

  const formatSizes = {
    a4: { width: 210, height: 297 },
    a3: { width: 297, height: 420 },
  };

  const size = formatSizes[pageSize];
  const pdfWidth = orientation === 'portrait' ? size.width : size.height;
  const pdfHeight = orientation === 'portrait' ? size.height : size.width;

  // jsPDF initialisieren
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({
    orientation: orientation,
    unit: 'mm',
    format: [pdfWidth, pdfHeight],
  });

  // Karte synchron rendern
  map.renderSync();

  // Canvas-Element der Karte extrahieren
  const mapCanvas = map.getViewport().querySelector('canvas');

  if (mapCanvas) {
    const canvasWidth = mapCanvas.width;
    const canvasHeight = mapCanvas.height;

    // Seitenverhältnis der Karte berechnen
    const canvasAspectRatio = canvasWidth / canvasHeight;
    const pdfAspectRatio = pdfWidth / pdfHeight;

    let imgWidth, imgHeight;
    if (canvasAspectRatio > pdfAspectRatio) {
      // Karte ist breiter als die PDF-Seite
      imgWidth = pdfWidth - 20; // Ränder (10 mm auf jeder Seite)
      imgHeight = imgWidth / canvasAspectRatio;
    } else {
      // Karte ist höher als die PDF-Seite
      imgHeight = pdfHeight - 20; // Ränder (10 mm oben und unten)
      imgWidth = imgHeight * canvasAspectRatio;
    }

    // Bilddaten aus dem Canvas extrahieren
    const imgData = mapCanvas.toDataURL('image/png');

    // Bild in das PDF einfügen (zentriert)
    const x = (pdfWidth - imgWidth) / 2;
    const y = (pdfHeight - imgHeight) / 2;
    doc.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
    
     // Rahmen um die Karte zeichnen
     doc.setDrawColor(0, 0, 0); // Schwarz
     doc.setLineWidth(0.5); // Linienbreite (0.5 mm)
     doc.rect(x, y, imgWidth, imgHeight);
      // Copyright-Hinweis hinzufügen
      const copyrightText = '© OpenStreetMap-Mitwirkende';
      const fontSize = 10;
      doc.setFontSize(fontSize);
      doc.text(copyrightText, 10, pdfHeight - 10); // 10 mm von der unteren linken Ecke
      const currentDate = new Date(); // Hier wird currentDate definiert
      const datum = currentDate.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
      doc.text("Ausdruck vom: " + datum,10,pdfHeight - 5);

      doc.text("Löschwasserentnahmestellen Gemeinde Bargfeld-Stegen mit Basiskarte - Openstreetmap",10, 13);
  

    // PDF speichern
    doc.save(`map_${pageSize}_${orientation}.pdf`);
  } else {
    console.error('Canvas konnte nicht gefunden werden.');
  }
});




});

/*var projx = new proj1({
        code: 'EPSG:3857',
        units: 'm'
});*/
// Ausdehnung von links unten (Rade) bis Sülfeld (rechts oben)...





/* const vecsource = new Vector({
  url: 'LES1.geojson',
  format: new GEOJSON({
    dataProjection: 'EPSG:3857',     // Original-Koordinaten (GeoJSON)
    featureProjection: 'EPSG:3857'   // Ziel für OpenLayers
  })
  }  ); */
   
//const lesvector300m = new VectorSource();
//function makeKreise() {
 // vecsource.on('change', function () {
    //if (vecsource.getState() === 'ready') {
      //console.log("Features geladen:", vecsource.getFeatures().length);
      //consolelog1.innerHTML = vecsource.getFeatures().length;

/* consolelog1.innerHTML = vecsource.getFeatures().length;
vecsource.on('featuresloadend', function () {
//const features = vecsource.getFeatures();

vecsource.getFeatures().forEach((feature)  => {
const geom = feature.getGeometry();

counter = counter + 1;
if ( geom instanceof Point) {

  const coord = geom.getCoordinates();

  const feat = new Feature(new Circle(coord,30));
  //feat.setProperties(feature.getProperties());
  lesvector300m.addFeature(feat);
counter++;
}

});

//});
//}
}); */


//consolelog1.innerHTML = counter;
//consolelog1.innerHTML = "jo";
//map.addLayer(les300m);
//}
//lesvector.on('featuresloadend',() => {


//});
  
 // var Circle300m = 
     

  //map.addLayer(les300m);
//map.addLayer(les);


//const btn_ladeDaten = document.getElementById('ladeDaten');
//btn_ladeDaten.addEventListener('click', function(){
//makeKreise();
//consolelog1.innerHTML = les300m.getFeatures().length;
//});

/*map.getView().on('change:resolution', function() {
  les300m.setStyle(Circle300m);

});*/




